import response from 'fe-coms/utils/response'
import Api from './api'
import Vue from '@/app.js'

const http = new Vue().$http
const action = {
  // 页签框架规则
  async getPageFrame ({commit}) {
    const api = Api.getRule
    commit('SET_PAGEFRAME_STATUS', 1)
    const res = await response(http(api.type, api.url, {key: 'page_frame_config'}))
    if (res.isOk) {
      commit('SET_PAGEFRAME', res.content || null)
    }
    commit('SET_PAGEFRAME_STATUS', 0)
  },
  async initPageFrame ({state, dispatch}) {
    if (state.pageFrame) {
      return
    }
    // 获取新的数据
    await dispatch('getPageFrame')
  },
  // 更新菜单列表
  async updateMenuList ({commit}) {
    const api = Api.listMenu
    const res = await response(http(api.type, api.url))
    if (res.isOk) {
      const list = res.content || []
      const menuMaps = {}
      list.forEach((v) => {
        v.appMenuList.forEach(v2 => {
          menuMaps[v2.url] = v2
        })
      })
      commit('SET_ALLMENU', menuMaps)
      commit('SET_APPLICATION_CLASSIFYLIST', list)
    }
  },
  // 初始化后台菜单列表
  async initMenuList ({state, dispatch}) {
    if (state.applicationClassifyList.length) {
      return
    }
    // 获取新的数据
    await dispatch('updateMenuList')
  }
}

export default action
